var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5625 0C43.5 0 48 4.5 48 11.4375V36.5625C48 43.5 43.5 48 36.5625 48H11.4375C4.5 48 0 43.5 0 36.5625V11.4375C0 4.5 4.5 0 11.4375 0H36.5625Z",
    fill: "url(#paint0_linear_2522_17275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7181 20.5565C13.7172 18.4178 14.3824 16.332 15.6214 14.5888C16.8604 12.8455 18.6117 11.5315 20.6318 10.8293C20.5535 10.3392 20.5826 9.83796 20.7169 9.36016C20.8512 8.88235 21.0875 8.43937 21.4096 8.06177C21.7317 7.68417 22.1319 7.38095 22.5826 7.17302C23.0333 6.9651 23.5237 6.85742 24.02 6.85742C24.5163 6.85742 25.0067 6.9651 25.4574 7.17302C25.9081 7.38095 26.3082 7.68417 26.6304 8.06177C26.9525 8.43937 27.1888 8.88235 27.3231 9.36016C27.4574 9.83796 27.4864 10.3392 27.4082 10.8293C29.4251 11.5344 31.1726 12.8496 32.4084 14.5926C33.6441 16.3356 34.3069 18.4199 34.3047 20.5565V30.8498L39.4514 34.2809V35.9965H8.57144V34.2809L13.7181 30.8498V20.5565ZM27.4425 37.712C27.4425 38.622 27.081 39.4947 26.4376 40.1382C25.7941 40.7816 24.9214 41.1431 24.0114 41.1431C23.1014 41.1431 22.2287 40.7816 21.5853 40.1382C20.9418 39.4947 20.5803 38.622 20.5803 37.712H27.4425Z",
    fill: "url(#paint1_linear_2522_17275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2522_17275",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2522_17275",
    x1: 16.8405,
    y1: 6.85742,
    x2: 16.8405,
    y2: 22.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.796818
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.68f3b3261baaf15bd5362ec58f7bbdc6.svg";
export { ForwardRef as ReactComponent };